export default {
  path: 'customers',
  name: 'orders.customers',
  component: () => import('@/views/admin/orders/default/customers/Index'),
}